import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { InputFieldModule } from '../input-field/input-field.module';
import { AccordionModule } from '../accordion/accordion.module';
import { DateRangeModule } from '../date-range/date-range.module';
import { InputSelectModule } from '../input-select/input-select.module';
import { SearchLocationModule } from '../search-location/search-location.module';
import { TitleModule } from '../title/title.module';
import { FlightChangeComponent } from './flight-change.component';
import { FilterComponent } from './filter/filter.component';
import { SearchAlternativesComponent } from './search-alternatives/search-alternatives.component';
import { InputSubmitModule } from '../input-submit/input-submit.module';
import { CheckBoxModule } from '../checkbox/checkbox.module';
import { SearchAirlineModule } from '../search-airline/search-airline.module';
import { ModalModule } from '../modal/modal.module';
import { SearchAirlineOffModule } from '../search-airline-off/search-airline-off.module';
import { AlertModule } from '../alert/alert.module';

@NgModule({
  imports: [
    CommonModule,
    AccordionModule,
    InputSelectModule,
    InputFieldModule,
    InputSubmitModule,
    CheckBoxModule,
    DateRangeModule,
    SearchLocationModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    TitleModule,
    SearchAirlineModule,
    SearchAirlineOffModule,
    ModalModule,
    AlertModule
  ],
  exports: [FlightChangeComponent, FilterComponent, SearchAlternativesComponent],
  declarations: [FlightChangeComponent, FilterComponent, SearchAlternativesComponent]
})
export class FlightChangeModule {}
